module.exports = __webpack_public_path__ + "f70f184e7f45a157590c290cd1e5396f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/trilliant.png
// module id = 764
// module chunks = 0